<template>
  <div class="ui fluid container fc-dashboard">
    <div class="fc-top-banner">
      <swiper :options="swiperOption" @slideChange="onSlideChange" ref="topBanner">
        <swiper-slide v-if="home.TopBanners.length > 0" v-for="banner in home.TopBanners" :style="{'background-color': banner.BgColor}" :key="banner.BannerId">
          <a :href="banner.Url">
            <img :src='banner.PhotoKey' />
            <div class="ui container">
              <div>
                {{ banner.Title }}
              </div>
              <div>{{ banner.Body }}</div>
              <div><a :href="banner.Url">START ORDER</a></div>
            </div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
      </swiper>
    </div>
    <div class="ui container fc-category-list">
      <div>
        <div>
          <a href="combo-package">
            <img src="../../static/img/MainMenu/MenuComboPackage.png" />
            <span>Quick Order</span>
          </a>
        </div>
      </div>
      <div>
        <div>
          <a href="sandwiches">
            <img src="../../static/img/MainMenu/MenuSandwiches.png" />
            <span>Sandwiches</span>
          </a>
        </div>
        <div>
          <a href="sub-platters">
            <img src="../../static/img/MainMenu/MenuPartyPlatters.png" />
            <span>Party Platters</span>
          </a>
        </div>
        <div>
          <a href="/">
            <img src="../assets/images/img-cashrewards.png" />
          </a>
        </div>
      </div>
      <div>
        <div>
          <a href="drinks">
            <img src="../../static/img/MainMenu/MenuDrinks.png" />
            <span>Drinks</span>
          </a>
        </div>
        <div>
          <a href="snacks-desserts">
            <img src="../../static/img/MainMenu/MenuSnacksDessert.png" />
            <span>Snacks/Desserts</span>
          </a>
        </div>
        <div>
          <a href="giant-sub">
            <img src="../../static/img/MainMenu/MenuGiantSub.png" />
            <span>Giant Sub</span>
          </a>
        </div>
      </div>
      <div>
        <div>
          <a href="lunch-boxes">
            <img src="../../static/img/MainMenu/MenuLunchboxes.png" />
            <span>Lunch Boxes</span>
          </a>
        </div>
      </div>
    </div>
    <div class="ui fluid container fc-catering">
      <swiper :options="bottomSwiperOption">
        <swiper-slide v-for="banner in home.BottomBanners" :style="{'background-color': banner.BgColor}" :key="banner.BannerId">
          <a :href="banner.Url">
            <img :src='banner.PhotoKey' />
            <div class="fc-cover"></div>
            <div class="ui container">
              <div>
                {{ banner.Title }}
              </div>
              <div>{{ banner.Body }}</div>
              <div><a :href="banner.Url">START ORDER</a></div>
            </div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
      </swiper>
    </div>
    <div class="ui fluid container fc-locations">
      <div class="ui container">
        <div><img src="../assets/images/img-avocado.png" /></div>
        <div>
          <p>OUR LOCATION</p>
          <div v-for="outlet in home.OurLocation">
            <span>{{ outlet.Name }}</span>
            <p v-html="outlet.Address">
              
            </p>
            <p>
              {{ outlet.Country }} {{ outlet.PostalCode }}
            </p>
            <p class="fc-tel">+{{ outlet.PhoneNumber }}</p>
            <span>Operation Hours:</span>
            <p v-html="outlet.OperatingHours"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  asyncData ({ store }) {
    return store.dispatch('home/getHome')
  },
  name: 'dashboard',
  // created () {
  //   return this.$store.dispatch('home/getHome')
  // },
  data () {
    return {
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet (index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">&nbsp;</span>`
          }
        }
      },
      bottomSwiperOption: {
        autoplay: false,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet (index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">&nbsp;</span>`
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('home', ['home'])
  },
  methods: {
    onSlideChange (e) {
      const swiper = this.$refs.topBanner.swiper
      const index = swiper.realIndex
      if (index === (swiper.slides.length - 1)) {
        setTimeout(() => {
          swiper.slideTo(0)
        }, 8000)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue